import { createFileRoute } from "@tanstack/react-router";
import LandingSectionPage from "@/pages/LandingSectionPage";
import { landingHead } from "@/lib/landingHead";
import { fetchHomeSsrData } from "@/lib/homeSsrData";

export const Route = createFileRoute("/estrategia")({
  head: () => landingHead("strategy", "es"),
  loader: () => fetchHomeSsrData(),
  component: EstrategiaRoute,
  errorComponent: () => <LandingSectionPage section="strategy" routeLang="es" />,
  notFoundComponent: () => <LandingSectionPage section="strategy" routeLang="es" />,
});

function EstrategiaRoute() {
  const data = Route.useLoaderData();
  return <LandingSectionPage section="strategy" routeLang="es" modules={data.modules} />;
}
